'use client';

import React from 'react';
import { Participant } from 'livekit-client';
import { useDebouncedConnectionQuality } from './useDebouncedConnectionQuality';

const QUALITY_ARIA: Record<string, string> = {
  excellent: 'Conexão excelente',
  good: 'Conexão boa',
  poor: 'Conexão ruim',
  lost: 'Conexão perdida',
  unknown: 'Qualidade de conexão desconhecida',
};

/** Ícone de barras compatível com estilos `.lk-connection-quality` do LiveKit. */
export function DebouncedConnectionQualityIndicator({
  participant,
}: {
  participant: Participant;
}) {
  const { quality } = useDebouncedConnectionQuality(participant);
  const label = QUALITY_ARIA[quality] ?? QUALITY_ARIA.unknown;

  const bars =
    quality === 'excellent'
      ? [4, 7, 10]
      : quality === 'good'
        ? [4, 7, 4]
        : quality === 'poor'
          ? [4, 4, 4]
          : quality === 'lost'
            ? [2, 2, 2]
            : [4, 4, 4];

  return (
    <span
      className="lk-connection-quality"
      data-lk-quality={quality}
      aria-label={label}
      title={label}
      style={{ display: 'inline-flex', alignItems: 'flex-end', gap: 2, height: 12 }}
    >
      {bars.map((h, i) => (
        <span
          key={i}
          style={{
            display: 'block',
            width: 3,
            height: h,
            borderRadius: 1,
            backgroundColor: 'currentColor',
          }}
        />
      ))}
    </span>
  );
}
